import { render, staticRenderFns } from "./MerchantMain.vue?vue&type=template&id=566fcdee"
import script from "./MerchantMain.vue?vue&type=script&lang=js"
export * from "./MerchantMain.vue?vue&type=script&lang=js"
import style0 from "./MerchantMain.vue?vue&type=style&index=0&id=566fcdee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports